import React from "react";

import { useAppSelector } from "../../../app/hooks";
import { cn } from "../../../lib/utils";
import { isCreditAreaOfFraud } from "../../caseinfo/logic/Slice";
import { isOperaionalCyberRevampEnabled } from "../../configs/logic/Slice";

import LoanAccountCard from "./LoanAccountCard";
import AccountsCard from "./AccountsCard";
import PartyCardContainer from "./PartyCardContainer";
import EmployeeCardContainer from "./EmployeeCardContainer";

const InvestigationEntitiesContainer: React.FC = () => {
  const isCreditFraud = useAppSelector(isCreditAreaOfFraud);
  const isCyberOpsRevampEnabled = useAppSelector(isOperaionalCyberRevampEnabled);

  return (
    <div className="mb-4">
      <p className="mb-2 text-xs font-medium text-[#737373]">
        Primary Parties
      </p>

      <div className={cn("grid gap-3", isCreditFraud || isCyberOpsRevampEnabled ? "grid-cols-3" : "grid-cols-2")}>
        {isCreditFraud && <LoanAccountCard />}
        {!isCreditFraud && isCyberOpsRevampEnabled && <AccountsCard />}
        <EmployeeCardContainer/>
        <PartyCardContainer />
      </div>
    </div>
  );
};

export default InvestigationEntitiesContainer;